module.exports = __webpack_public_path__ + "static/media/main_bg.07cf44af.png";